export const getTotalPrice = products => products?.map(({ total }) => total)?.reduce((a, b) => a + b, 0)

export const findProduct = (lines, product) => lines.find(line => line.reference === product.reference)
